import type { FaireProductEntity } from "../../entity_types/product";

export const p_5qx242qxfn: FaireProductEntity = {
  token: "p_5qx242qxfn",
  type: "product",
  name: "Mentos Peach & Soda Gummy 45g (Korea)",
  brandToken: "b_s2gzfhxg44",
  brandName: "Global Bite Co",
  imageUrl:
    "https://cdn.faire.com/fastly/8771b7790552eeef250d719210fb282c66c23cf5665c6dc4ae3b892c503e8d6c.jpeg",
  galleryImageUrls: [],
  priceDollars: 2.83,
  description:
    "Enjoy a refreshing twist on fruity gummies with Mentos Peach & Soda Gummy, a Korean-exclusive candy that blends juicy peach sweetness with a bubbly soda kick. Each soft, chewy gummy delivers a burst of ripe peach flavor followed by a lightly fizzy, soda-inspired finish — making it both refreshing and addictive.\n\nPerfect for on-the-go snacking, sharing with friends, or adding to your international candy collection, this 45g pouch packs a fun, flavorful punch.\n\n✅ Authentic Korean Mentos gummy candy\n✅ Juicy peach flavor blended with refreshing soda-fizz taste\n✅ Soft, chewy texture with a bright fruity aroma\n✅ Small, portable pouch perfect for travel or snacking\n\nSweet, fizzy, and irresistibly chewy — Mentos Peach & Soda Gummy (Korea Edition) brings a sparkling twist to traditional fruit gummies.\n",
  tags: [],
  msrpDollars: 5.22,
  inStock: true,
  meta: {
    source: "api",
    importedAt: "2026-03-26T22:54:18.462Z",
    importedBy: "entity-db-cli",
  },
  categoryTokens: [],
};
